// src/domains/core/dashboard/components/layout/DashboardGrid.tsx

import { type FC, type ReactNode } from "react";

import { cn } from "@/shared/utils";

interface DashboardGridProperties {
  children: ReactNode;
  className?: string;
}

/**
 * DashboardGrid - Responsive Grid-Layout für Dashboard-Widgets
 *
 * Verwendet CSS Grid mit automatischer Anpassung an Widget-Größen
 *
 * @param root0
 *
 * @param root0.children
 *
 * @param root0.className
 *
 * @returns Dashboard grid layout component
 *
 */
export const DashboardGrid: FC<DashboardGridProperties> = ({ children, className }) => {
  return (
    <div
      className={cn(
        "grid gap-4 w-full",
        "grid-cols-1",
        "sm:grid-cols-2",
        "md:grid-cols-2",
        "lg:grid-cols-2",
        "xl:grid-cols-3",
        "2xl:grid-cols-4",
        className,
      )}
    >
      {children}
    </div>
  );
};
